import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addTeamMember } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const AddMember = ({ onClose }) => {
	const [inputData, setInputData] = useState({});
	const [errors, setErrors] = useState({});
	const dispatch = useDispatch();
	const { id } = useParams();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputData((prev) => ({ ...prev, [name]: value }));
	};

	const isValid = () => {
		let err = {};
		if (!inputData?.name) {
			err['nameError'] = 'Field is required';
		}
		if (!inputData?.email) {
			err['emailError'] = 'Field is required';
		}
		if (!inputData?.contactNumber) {
			err['contactNumberError'] = 'Field is required';
		}
		if (!inputData?.designation) {
			err['designationError'] = 'Field is required';
		}
		setErrors(err);
		return Object.keys(err).length <= 0;
	};

	const handleSubmit = async () => {
		if (isValid()) {
			try {
				dispatch(openLoader());
				await addTeamMember(id, inputData);
				dispatch(closeLoader());
				onClose(true);
			} catch (e) {
				dispatch(closeLoader());
				printApiError(e);
			}
		}
	};

	return (
		<ModalContainer className="filter-quick-search-modal">
			<div className="common-popup filter-quick-search-modal">
				<ModalHeader title="Add Member" onClose={onClose} />
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Member Name</label>
								<input
									type="text"
									className="w-100"
									value={inputData?.name || ''}
									name="name"
									onChange={handleChange}
								/>
								{errors?.nameError && <p className="error">{errors.nameError}</p>}
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Mobile Number</label>
								<input
									type="text"
									className="w-100"
									value={inputData?.contactNumber || ''}
									name="contactNumber"
									onChange={handleChange}
								/>
								{errors?.contactNumberError && (
									<p className="error">{errors.contactNumberError}</p>
								)}
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Email</label>
								<input
									type="email"
									className="w-100"
									value={inputData?.email || ''}
									name="email"
									onChange={handleChange}
								/>
								{errors?.emailError && <p className="error">{errors.emailError}</p>}
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Designation</label>
								<input
									type="text"
									className="w-100"
									value={inputData?.designation || ''}
									name="designation"
									onChange={handleChange}
								/>
								{errors?.designationError && (
									<p className="error">{errors.designationError}</p>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32 ml-2" type="submit" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddMember;
